import React from 'react';
import benefitAdjustmentsService from '../../services/claim/benefit_adjustments.service';
import ClaimFieldsTable from './ClaimFieldsTable';
import AdjustmentsRow from './AdjustmentsRow';
export default function AdjustmentOfTradingProfitTable(_ref) {
  let {
    claim,
    calculations,
    setClaim,
    setLoading,
    refreshCalculations
  } = _ref;
  const [adjustments, setAdjustments, fetchAdjustments] = benefitAdjustmentsService.useFetchAll({
    claimId: claim.id,
    setLoading
  });
  const adductions = adjustments.filter(adjustment => adjustment.adjustment_type === 'adduction');
  const deductions = adjustments.filter(adjustment => adjustment.adjustment_type === 'deduction');
  calculations.adductionsAmountSum = adductions.reduce((sum, a) => sum += parseFloat(a.amount), 0);
  calculations.deductionsAmountSum = deductions.reduce((sum, d) => sum += parseFloat(d.amount), 0);
  const rows = [{
    text: 'Profit / (loss per accounts)',
    field_1: {
      name: 'profit_loss_per_accounts',
      editable: true
    },
    field_2: {
      name: 'profit_loss_per_accounts'
    }
  }, {
    render: () => /*#__PURE__*/React.createElement(AdjustmentsRow, {
      type: "adduction",
      claim: claim,
      setLoading: setLoading,
      adjustments: adjustments,
      setAdjustments: setAdjustments
    }),
    field: {
      name: 'adductionsAmountSum'
    }
  }, {
    render: () => /*#__PURE__*/React.createElement(AdjustmentsRow, {
      type: "deduction",
      claim: claim,
      setLoading: setLoading,
      adjustments: adjustments,
      setAdjustments: setAdjustments
    }),
    field: {
      name: 'deductionsAmountSum'
    }
  }, {
    text: 'Qualifying s1308 deduction',
    field: {
      name: 'qualifying_s1308_deduction'
    }
  }, {
    text: 'Total SME R&DTR deduction',
    field: {
      name: 'total_sme_rnd_tr_deduction'
    },
    shouldDisplay: claim.rate_types_qualified_for.sme
  }, {
    text: 'Total ERIS deduction',
    field: {
      name: 'total_eris_deduction'
    },
    shouldDisplay: claim.rate_types_qualified_for.eris
  }, {
    text: 'Total old RDEC',
    field: {
      name: 'total_old_rdec'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'Total RDEC merged scheme',
    field: {
      name: 'total_rdec_merged_scheme'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'Trading profit/(loss)',
    field_1: {
      name: 'trading_pnl_1'
    },
    field_2: {
      name: 'trading_pnl_2'
    }
  }, {
    className: 'color-red',
    text: 'Check above',
    field: {
      name: null
    }
  }, {
    className: 'ps-5',
    text: 'Trading profit/(loss) per client tax comp',
    field_1: {
      name: 'trading_profit_per_client_tax_comp',
      editable: true
    },
    field_2: {
      name: 'trading_profit_per_client_tax_comp',
      editable: true
    }
  }, {
    className: 'ps-5',
    text: 'Reconciliation',
    field: {
      name: 'reconciliation'
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Adjustment of trading profit",
    rows: rows
  });
}